module.exports = "/img/10.ab4dc7.webp";